import { Capacitor } from "@capacitor/core";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { http, handle } from "@/api/http";

let configuredFor = null;

export async function configureIap(userId) {
  if (configuredFor === userId) return;
  const config = await handle(http.get("/iap/config"));
  const apiKey = Capacitor.getPlatform() === "ios" ? config.ios_key : config.android_key;
  if (!apiKey) throw new Error("not_configured");
  if (configuredFor) await Purchases.logIn({ appUserID: userId });
  else await Purchases.configure({ apiKey, appUserID: userId });
  configuredFor = userId;
}

export async function lifetimePackage() {
  const offerings = await Purchases.getOfferings();
  const packages = offerings.current?.availablePackages || [];
  return packages.find((p) => p.packageType === "LIFETIME") || packages[0] || null;
}

export const buyPackage = (aPackage) => Purchases.purchasePackage({ aPackage });
export const restorePurchases = () => Purchases.restorePurchases();
export const syncAccess = () => handle(http.post("/iap/sync"));
